/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Swiper.use([Navigation]);
export function slider() {
    const latestCasesSliderselector = ".cases-list__items-container.swiper";
    const latestArticlesSliderselector = ".articles-list__items-container.swiper";
    const testimonialSliderSelector = ".testimonial-slider__inner.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }


    const init = function () {
        // Latest Cases sliders
        const latestCasesSliders = [];
        const latestCasesSlidersElements = document.querySelectorAll(latestCasesSliderselector);
        if (latestCasesSlidersElements) {
            latestCasesSlidersElements.forEach(slider => {
                latestCasesSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    navigation: {
                        el: ".slider-navigation",
                        clickable: true,
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            });
        }

        // Latest Articles sliders
        const latestArticlesSliders = [];
        const latestArticlesSlidersElements = document.querySelectorAll(latestArticlesSliderselector);
        if (latestArticlesSlidersElements) {
            latestArticlesSlidersElements.forEach(slider => {
                latestArticlesSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    navigation: {
                        el: ".slider-navigation",
                        clickable: true,
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            });
        }

        // Testimonial sliders
        const testimonialSliders = [];
        const testimonialSlidersElements = document.querySelectorAll(testimonialSliderSelector);
        if (testimonialSlidersElements) {
            testimonialSlidersElements.forEach(slider => {
                testimonialSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                    navigation: {
                        el: ".slider-navigation",
                        clickable: true,
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    breakpoints: {
                        1185: {
                            slidesPerView: 1.7,
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            });
        }
    }

    init();

}
